import classNames from 'classnames';
import React, { useContext } from 'react';
import {
  Archive,
} from '@styled-icons/feather';
import sharedStyles from '../../styles/Shared.module.css';
import styles from './UnsavedChangesButton.module.css';
import { UnsavedPagesContext } from '../../context/UnsavedPagesContext';
import PulsatingCircle from '../PulsatingCircle';

function UnsavedChangesButton() {
  const { unsavedPages, setopenUnsavedPages } = useContext(UnsavedPagesContext);

  if (unsavedPages) {
    return (
      <div
        className={classNames(sharedStyles.sidebarItem, 'with-light-text-color', 'pb-0')}
      >
        <div
          className={classNames('box-border', 'has-fullwidth', 'with-accent-border-color', styles.button)}
          onClick={() => setopenUnsavedPages(true)}
          role="none"
        >
          <div className="is-flex is-align-items-center">
            <Archive size={15} style={{ marginRight: 5 }} />
            Unsaved Changes
          </div>
          <div
            className={classNames('is-flex with-accent-text-color')}
          >
            Review
          </div>
          <PulsatingCircle className={styles.circleRight} />
        </div>
      </div>
    );
  }
  return <> </>;
}

export default UnsavedChangesButton;
